import { render, staticRenderFns } from "./DownloadDetailPage.vue?vue&type=template&id=2a99b366&scoped=true"
import script from "./DownloadDetailPage.vue?vue&type=script&lang=js"
export * from "./DownloadDetailPage.vue?vue&type=script&lang=js"
import style0 from "./DownloadDetailPage.vue?vue&type=style&index=0&id=2a99b366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a99b366",
  null
  
)

export default component.exports